import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Loading from '@/components/loading/loading'
import { isAlreadyBought } from '@/plugins/products_helper'

@Component({
  components: {
    Loading
  }
})
export default class CheckoutProducts extends Vue {

  @Prop({ default: false }) loading
  @Prop({ default: () => [] }) cartProducts
  @Prop({ default: null }) cart

  @Getter getCountry
  
  @Action action_addCartProducts: any;
  @Action action_removeCartProducts: any;

  currentCartProducts = []
  showProducts = false;
  isLoading = false;

  mounted() {
    this.cartChanged();
  }

  @Watch('cart', { deep: true })
  cartChanged() {
    this.currentCartProducts = [...this.cartProducts];
  }

  @Watch('loading')
  onCheckoutLoading() {
    this.isLoading = this.loading;
  }

  get getProductsQuantity() {
    const numberOfProducts = this.currentCartProducts ? this.currentCartProducts.length : 0;
    if(numberOfProducts !== 1) {
      return `${numberOfProducts} Productos`;
    } else {
      return `${numberOfProducts} Producto`;
    }
  }

  get getSortedProducts() {
    return this.currentCartProducts.sort(this.compareProductsNames);
  }

  get getShowHideButtonLabel() {
    if(this.showProducts) {
      return "Ocultar";
    }
    return "Ver más";
  }

  get getShowHideArrow() {
    if(this.showProducts) {
      return 'ion-ios-arrow-up';
    }
    return 'ion-ios-arrow-down';
  }

  getDiscountLabel(item) {
    let discountLabel = "";
    if(item && item.quantity_product_discount && item.price_discount) {
      const quantityProductDiscount = item.quantity_product_discount;
      const priceDiscount = parseFloat(item.price_discount);
      discountLabel = `${quantityProductDiscount} unidad(es) con descuento ${this._money(priceDiscount)}`;
    }
    return discountLabel;
  }

  getNormalPriceLabel(item) {
    let priceLabel = "";
    if(item && item.quantity_product && item.base_price) {
      const quantityProduct = item.quantity_product;
      const basePrice = parseFloat(item.base_price);
      priceLabel = `${quantityProduct} unidad(es) con descuento ${this._money(basePrice)}`;
    }
    return priceLabel;
  }

  getFreeProductLabel(item) {
    let response = "";
    if(item && item.quantity_product_coupon_free && item.price_coupon_free >= 0) {
      const quantityFree = item.quantity_product_coupon_free;
      const priceCouponFree = item.price_coupon_free;
      response = `${quantityFree} unidad(es) con valor ${this._money(priceCouponFree)}`;
    }
    return response;
  }

  isFreeProduct(item) {
    let response = false;
    if(item && item.quantity_product_coupon_free) {
      response = true;
    }
    return response;
  }

  _isAlreadyBought(item) {
    let response = false;
    if(item && item.product_id) {
      response = isAlreadyBought(item.product_id);
    }
    return response;
  }

  isPromoExceeded(item) {
    if(item && item.promo && item.promo.max_promos_per_cart && item.quantity_total) {
      return item.promo.max_promos_per_cart < item.quantity_total;
    }
    return false;
  }

  isMinusButtonDisabled(index) {
    return this.currentCartProducts.length === 1 && this.getProductQuantity(index) === 1;
  }

  compareProductsNames(productA, productB) {
    let res = 0;
    if(productA.name < productB.name) {
      res = -1;
    } else if(productA.name > productB.name) {
      res = 1;
    }
    return res;
  }

  _money(val) {
    const price = parseFloat(val)
    return this.$currency.format(price, { code: this.getCountry.currency })
  }

  getProductQuantity(index) {
    if(this.currentCartProducts[index] && this.currentCartProducts[index].quantity_total) {
      return this.currentCartProducts[index].quantity_total;
    }
  }

  async changeProductQuantity(item, quantity) {
    let product = null;
    this.isLoading = true;
    this.$emit('updateCart', true);
    try {
      if(quantity > 0) {
        // Sumar un producto
        product = {
          product_id: item.product_id,
          qty: 1
        };
        await this.action_addCartProducts({
          products: [product]
        });
      } else if(quantity < 0) {
        // Quitar un producto
        if(this.isAbleToRemove(item)) {
          product = {
            product_id: item.product_id,
            qty: 1,
            type: "remove"
          };
          await this.action_removeCartProducts({
            products: [product]
          });
        }
      }
    } catch (error) {
      this.$swal({
        title: "Error",
        text: "¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo." + error
      });
    }
    this.isLoading = false;
    this.$emit('updateCart', false);
  }

  showBasePrice(item) {
    let response = false;
    if(item && item.quantity_product_coupon_free && item.quantity_product) {
      response = true;
    }
    if(item && item.quantity_product_discount && item.quantity_product) {
      response = true;
    }
    return response;
  }

  isAbleToRemove(item) {
    let response = true;
    if(item && item.quantity_total >= 0 && item.quantity_product_coupon_free >= 0) {
      const total = item.quantity_total;
      const free = item.quantity_product_coupon_free;
      return total > free;
    }
    return response;
  }

  getMinusButtonLabel(item) {
    return this.isAbleToRemove(item) ? "-" : " ";
  }

  _toggleProducts() {
    this.showProducts = !this.showProducts;
  }
}
